<template>
  <sidenav
    :custom_class="this.$store.state.mcolor"
    :class="[
      this.$store.state.isTransparent,
      this.$store.state.isRTL ? 'fixed-end' : 'fixed-start',
    ]"
    v-if="this.$store.state.showSidenav"
  />
  <main
    class="main-content position-relative max-height-vh-100 h-100 border-radius-lg"
    :style="this.$store.state.isRTL ? 'overflow-x: hidden' : ''"
    id="main-content"
    role="main"
  >
    <!-- nav -->
    <navbar
      :class="[navClasses]"
      :textWhite="this.$store.state.isAbsolute ? 'text-white opacity-8' : ''"
      :minNav="isNavbarMinimized"
      v-if="this.$store.state.showNavbar"
    />
    <router-view v-slot="{ Component }">
      <component :is="Component" />
    </router-view>
    <app-footer v-show="this.$store.state.showFooter" id="footer-main" />
    <bottom-nav />
    <configurator
      :toggle="toggleConfigurator"
      :class="[
        this.$store.state.showConfig ? 'show' : '',
        this.$store.state.hideConfigButton ? 'd-none' : '',
      ]"
    />
  </main>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import Sidenav from "./examples/Sidenav";
import Navbar from "@/examples/Navbars/Navbar.vue";
import AppFooter from "@/examples/Footer.vue";
import BottomNav from "@/examples/BottomNav.vue";
import Configurator from "@/examples/Configurator.vue";

export default {
  name: "App",
  components: {
    Sidenav,
    Navbar,
    AppFooter,
    BottomNav,
    Configurator,
  },
  
  computed: {
    ...mapState({
      isNavbarMinimized: 'isNavbarMinimized'
    }),
    
    navClasses() {
      return {
        "position-sticky blur shadow-blur mt-4 left-auto top-1 z-index-sticky": this
          .$store.state.isNavFixed,
        "position-absolute px-4 mx-0 w-100 z-index-2": this.$store.state
          .isAbsolute,
        "px-0 mx-4 mt-4": !this.$store.state.isAbsolute,
      };
    },
  },
  
  data() {
    return {
      previousRoute: null,
      currentRoute: null,
      isPageTransitioning: false
    }
  },
  
  watch: {
    '$route'(to, from) {
      this.previousRoute = from
      this.currentRoute = to
    }
  },
  
  beforeMount() {
    this.$store.state.isTransparent = "bg-transparent";
  },
  
  mounted() {
    // Initialize route tracking
    this.currentRoute = this.$route
    
    // Add skip link for accessibility
    this.addSkipLink()
  },
  
  methods: {
    ...mapMutations(["toggleConfigurator", "navbarMinimize"]),
    
    addSkipLink() {
      const skipLink = document.createElement('a')
      skipLink.href = '#main-content'
      skipLink.textContent = 'Saltar al contenido principal'
      skipLink.className = 'skip-link'
      skipLink.style.cssText = `
        position: absolute;
        top: -40px;
        left: 6px;
        background: var(--primary-600, #2563eb);
        color: white;
        padding: 8px;
        text-decoration: none;
        border-radius: 4px;
        z-index: 1000;
        transition: top 0.3s ease;
      `
      
      skipLink.addEventListener('focus', () => {
        skipLink.style.top = '6px'
      })
      
      skipLink.addEventListener('blur', () => {
        skipLink.style.top = '-40px'
      })
      
      document.body.insertBefore(skipLink, document.body.firstChild)
    }
  }
};
</script>

<style>
/* Asegurar espacio para el bottom navigation en móviles */
@media (max-width: 991.98px) {
  .main-content {
    padding-bottom: calc(70px + env(safe-area-inset-bottom)) !important;
  }
  
  /* Ajustar el footer para que no interfiera con el bottom nav */
  .footer {
    padding-bottom: calc(70px + env(safe-area-inset-bottom));
  }
}

/* Evitar scroll horizontal en dispositivos móviles */
@media (max-width: 991.98px) {
  body {
    overflow-x: hidden;
  }
  
  .main-content {
    overflow-x: hidden;
  }
}

/* Screen reader only text */
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
</style>